import * as React from "react";

interface Props {
  size?: number;
  color?: string;
}

const KeyIconV1 = ({ size = 18, color = "currentColor" }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="7.5" cy="15.5" r="3.5" />
    <path d="M10 13L20 3" />
    <path d="M16.5 6.5l3 3" />
    <path d="M14 9l3 3" />
  </svg>
);

export default KeyIconV1;
